<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

  document.querySelectorAll('a').forEach(link => {
  link.addEventListener('mouseover', function() {
    this.dataset.title = this.getAttribute('title');
    this.removeAttribute('title');
  });
  link.addEventListener('mouseout', function() {
    this.setAttribute('title', this.dataset.title);
  });
});

/* ============================================================================
   Setosa site-wide enhancements
   ============================================================================ */
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  ready(function () {
    /* ---- Scroll progress bar ---- */
    try {
      var bar = document.createElement('div');
      bar.id = 'setosa-progress';
      document.body.appendChild(bar);
      var onScroll = function () {
        var h = document.documentElement;
        var max = (h.scrollHeight - h.clientHeight) || 1;
        bar.style.width = (Math.min(1, h.scrollTop / max) * 100) + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    } catch (e) {}

    if (REDUCE) return;

    /* ---- Scroll reveal ---- */
    try {
      var targets = [];
      document.querySelectorAll(
        '.sp .sp-section, .sp .sp-card, .sp .sp-gallery, .sc .sc-hero, .sc .sc-trust, .sc .sc-card'
      ).forEach(function (el) { targets.push(el); });

      if (targets.length && 'IntersectionObserver' in window) {
        targets.forEach(function (el, i) {
          el.classList.add('setosa-reveal');
          el.style.transitionDelay = ((i % 6) * 0.05) + 's';
        });
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
          });
        }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
        targets.forEach(function (el) { io.observe(el); });
      }
    } catch (e) {}

    /* ---- Magnetic primary buttons (desktop only) ---- */
    try {
      var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
      if (fine) {
        document.querySelectorAll('.setosa-gradient-btn, .sh-btn, .sp-add, .sc-card__cta, .sp-sticky__btn')
        .forEach(function (btn) {
          btn.style.willChange = 'transform';
          btn.addEventListener('mousemove', function (e) {
            var r = btn.getBoundingClientRect();
            var mx = e.clientX - r.left - r.width / 2;
            var my = e.clientY - r.top - r.height / 2;
            btn.style.transform = 'translate(' + (mx * 0.12) + 'px,' + (my * 0.18) + 'px)';
          });
          btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
        });
      }
    } catch (e) {}
  });
})();

/* ============================================================================
   Setosa PDP enhancements v3
   ============================================================================ */
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  ready(function () {
    /* ---- FREE-GIFT promo banner ---- */
    try {
      var host = document.querySelector('.halo-productView-right')
              || document.querySelector('.sp-info');
      if (host && !document.getElementById('setosa-gift')) {
        var box = document.createElement('div');
        box.id = 'setosa-gift';
        box.className = 'setosa-glass-strong is-static';
        box.innerHTML = '<div class="sg-top"><span class="sg-ico">🎁</span>'
          + '<span class="sg-msg"><strong>Get Free Toner or Cleanser on Orders Above 5k+</strong></span></div>';
        host.insertBefore(box, host.firstChild);
        var top = box.querySelector('.sg-top'); if (top) top.style.marginBottom = '0';
      }
    } catch (e) {}

    if (REDUCE || !FINE) return;

    /* ---- 3D tilt on product image ---- */
    try {
      var tiltEls = document.querySelectorAll(
        '.halo-productView-left .productView-image, .sp-main, .sh-why__card, .sp-card'
      );
      tiltEls.forEach(function (el) {
        var max = el.classList.contains('productView-image') || el.classList.contains('sp-main') ? 7 : 5;
        el.addEventListener('mousemove', function (e) {
          var r = el.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          el.style.transform = 'perspective(1000px) rotateY(' + (px * max) + 'deg) rotateX(' + (-py * max) + 'deg) scale(1.02)';
        });
        el.addEventListener('mouseleave', function () { el.style.transform = ''; });
      });
    } catch (e) {}
  });
})();

/* ============================================================================
   Product card hover image swap — force-load second images
   The theme uses lazysizes (data-srcset). Second/hover images are invisible
   until lazysizes processes them. We trigger loading immediately when cards
   enter the viewport so the swap works instantly on hover.
   ============================================================================ */
(function () {
  function loadHoverImages(root) {
    var hoverImgs = (root || document).querySelectorAll(
      '.card-media.media--hover-effect > img + img'
    );
    hoverImgs.forEach(function (img) {
      if (img.classList.contains('lazyload') || img.dataset.srcset) {
        /* Force lazysizes to load this image now */
        if (window.lazySizes) {
          lazySizes.loader.unveil(img);
        }
        /* Also set srcset directly as a fallback */
        if (img.dataset.srcset && !img.srcset) {
          img.srcset = img.dataset.srcset;
          img.removeAttribute('data-srcset');
        }
        if (img.dataset.src && !img.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
        img.classList.remove('lazyload');
        img.classList.add('lazyloaded');
      }
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  ready(function () {
    /* Load hover images for all visible cards immediately */
    loadHoverImages(document);

    /* Also load when new cards enter the viewport (infinite scroll / sliders) */
    if ('IntersectionObserver' in window) {
      var cardObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            loadHoverImages(en.target);
            cardObserver.unobserve(en.target);
          }
        });
      }, { rootMargin: '200px' });
      document.querySelectorAll('.card-media.media--hover-effect').forEach(function (card) {
        cardObserver.observe(card);
      });
    }

    /* Watch for dynamically injected cards (quick view, sliders, etc.) */
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) loadHoverImages(node);
          });
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  });
})();

/* ============================================================================
   BOGOS Volume Discount — product image injection
   ============================================================================ */
(function () {
  var injected = false;

  function injectBogosImages() {
    if (injected) return;
    var widget = document.querySelector('.bogos-volume-discount-widget');
    if (!widget) return;
    var nameEls = widget.querySelectorAll('.bogos-volume-discount-name');
    if (!nameEls.length) return;

    var handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var raw = product.featured_image || (product.images && product.images[0]) || '';
        if (!raw) return;
        var imgSrc = raw.replace(/(\.[a-z]+)(\?.*)?$/i, '_80x80$1');

        nameEls.forEach(function (nameEl) {
          if (nameEl.querySelector('.bogos-injected-img')) return;
          var img = document.createElement('img');
          img.src = imgSrc;
          img.alt = product.title || '';
          img.className = 'bogos-injected-img';
          img.loading = 'lazy';
          nameEl.insertBefore(img, nameEl.firstChild);
        });
        injected = true;
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBogosImages, { once: true });
  } else {
    injectBogosImages();
  }

  if ('MutationObserver' in window) {
    var bogosObserver = new MutationObserver(function () {
      if (!injected) injectBogosImages();
    });
    bogosObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
